import { render } from "./PersonsByContractQCPage.vue?vue&type=template&id=2ee2dde1&scoped=true"
import script from "./PersonsByContractQCPage.vue?vue&type=script&lang=js"
export * from "./PersonsByContractQCPage.vue?vue&type=script&lang=js"

import "./PersonsByContractQCPage.vue?vue&type=style&index=0&id=2ee2dde1&scoped=true&lang=css"

import exportComponent from "D:\\Projects\\JCXS\\CAAMSNG\\frontend-caams\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ee2dde1"]])

export default __exports__